const getValidUrl = (value = ''): string => {
    if (!value.startsWith('http')) {
        return `http://${value}`
    } else {
        return value
    }
}

export default getValidUrl